import { METRIC_NAMES } from '@config/Consts';

class ManagerMetricsModel {
  constructor(options) {
    this[METRIC_NAMES.CLOSED_CONVERSATIONS] =
      options[METRIC_NAMES.CLOSED_CONVERSATIONS];
    this[METRIC_NAMES.ASSIGNED_CONVERSATIONS] =
      options[METRIC_NAMES.ASSIGNED_CONVERSATIONS];
    this[METRIC_NAMES.AVG_WAIT_TIME] =
      options[METRIC_NAMES.AVG_WAIT_TIME];
    this[METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE] =
      options[METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE];
    this[METRIC_NAMES.AVG_TIME_TO_RESPONSE] =
      options[METRIC_NAMES.AVG_TIME_TO_RESPONSE];
    this[METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT] =
      options[METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT];
    this[METRIC_NAMES.HUMAN_ONLINE_LOAD] =
      options[METRIC_NAMES.HUMAN_ONLINE_LOAD];
    this[METRIC_NAMES.HUMAN_AWAY_LOAD] =
      options[METRIC_NAMES.HUMAN_AWAY_LOAD];
    this[METRIC_NAMES.LOAD_CONVERSATIONS] =
      options[METRIC_NAMES.LOAD_CONVERSATIONS];
    this[METRIC_NAMES.AUTO_CLOSED] =
      options[METRIC_NAMES.AUTO_CLOSED];
    this[METRIC_NAMES.CLOSED_BY_AGENT] =
      options[METRIC_NAMES.CLOSED_BY_AGENT];
    this[METRIC_NAMES.CLOSED_BY_CONSUMER] =
      options[METRIC_NAMES.CLOSED_BY_CONSUMER];
    this[METRIC_NAMES.AVG_CONVERSATIONS_DURATION] =
      options[METRIC_NAMES.AVG_CONVERSATIONS_DURATION];
  }
}

export default ManagerMetricsModel;
